import type { FormikConfig } from 'formik';

export interface ResetPasswordPageFormValues {
  password: string;
  passwordConfirm: string;
}

export interface ResetPasswordPageData {
  form: FormikConfig<ResetPasswordPageFormValues>;
}

export interface ResetPasswordPageProps extends ResetPasswordPageData {}
